import Card from "components/card";

const FourthCardSx = () => {
    return (
        <Card extra="flex w-full flex-col p-4">
            <p className="text-[14.5px]">
                Hai individuato un errore? Puoi modificarlo nella sezione
                ‘Riepilogo Richiesta’ in alto a destra cliccando sul bottone
                ‘Modifica’, oppure procedere con la conferma dell’ordine
                cliccando sul bottone ‘Conferma’.
            </p>
        </Card>
    );
};

export default FourthCardSx;
